module.exports = __webpack_public_path__ + "static/object-1-f7238b2f6183e56c09285b46073ee5e8.png";